import * as actionTypes from './actionTypes';

export const breadcrumbAddRoute = (crumb) => {
    return {
        type: actionTypes.BREADCRUMB_ADD_ROUTE,
        crumb: crumb
    };
};

export const breadcrumbRemoveRoute = (lastRouteIndex = null) => {
    return {
        type: actionTypes.BREADCRUMB_REMOVE_ROUTE,
        lastRouteIndex: lastRouteIndex
    };
};

export const breadcrumbRemoveAllRoutes = () => {
    return {
        type: actionTypes.BREADCRUMB_REMOVE_ALL_ROUTES
    };
};
